import { createContext, useContext } from 'react';

/** 当前 KeepAlive 窗格是否为激活页签。未包在 KeepAliveOutlet 内时视为激活。 */
export const KeepAlivePaneContext = createContext(true);

export function useKeepAlivePaneActive() {
    return useContext(KeepAlivePaneContext);
}
